<!--

A simple text box that features a title and optional subtitle.

You can change the default title background or text color like this:

<text-box-title
  title-bg="red1"
  title-text="black"
>
Words...
</text-title-box>

You can change either one, or both.

This component features the ability to have separate titles on their
own line via: title2, title3, and title4.

Each extra title will be on it's own line. A usage for this is if you want
to make sure certain words are grouped together when device screen size
changes.

!! Only use the multi-line title feature if you are sure words won't be
too large to be grouped together. If they are, the overflow will be hidden.
Use with caution.

-->

<template>
  <div>
    <div v-if="block">

      <div class="block-title" v-bind:class="{[bgColor]: true, [textColor]: true}">
        <span class="text-success">|</span> {{title}} <span class="one-line"> {{title2}} </span> <span class="one-line"> {{title3}} </span> <span class="one-line"> {{title4}} </span>
        <span v-if="subtitle">
          <span class="subtitle">
            {{subtitle}}
          </span>
        </span>
      </div>
      <div class="row copy general">
        <slot></slot>
      </div>

    </div>

    <div v-else>

      <div class="underline-title" v-bind:class="{[textColor]: true}">
        <span class="text-success">|</span> {{title}} <span class="one-line">{{title2}}</span> <span class="one-line">{{title3}}</span> <span class="one-line">{{title4}}</span>
        <hr />
        <span v-if="subtitle">
          <span class="subtitle">
            {{subtitle}}
          </span>
        </span>
      </div>
      
      <div class="row underline-copy general">
        <slot></slot>
      </div>

    </div> <!-- end if -->

  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      defaultBg: "",
      defaultText: "text-primary",
      bgColor: "",
      textColor: ""
    }
  },
  props: ['title','title2','title3','title4','title-bg','title-text','subtitle','block','icon'],
  created: function() {
    this.checkColors()
    this.checkStyle()
  },
  methods: {
    checkColors: function() {
      if (this.titleBg != null && this.titleBg != "") {
        this.bgColor = "bg-" + this.titleBg
      } else {
        this.bgColor = this.defaultBg
      }

      if (this.titleText != null && this.titleText != "") {
        this.textColor = "text-" + this.titleText
      } else {
        this.textColor = this.defaultText
      }
    },
    checkStyle: function() {
      //
    }
  }
}
</script>

<style scoped>
  .block-title {
    display: block;
    width: 100%;
    font-size: 1.5em;
    font-weight: bold;
    padding: 1.0em 0 0 0;
    line-height: 1.5em;
  }

  .underline-title {
    display: block;
    width: 100%;
    font-size: 1.5em;
    font-weight: bold;
    padding: 1.0em 0 0 0;
    line-height: 1.5em;
  }

  .underline-title hr {
    border-top: 2px solid #73835b;
}

  .general a:hover {
    text-decoration: underline;
  }

  .general ul {
    padding: 0;
    margin: 0;
    list-style-type: disc;
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 0px;
  }

  .copy p {
    margin: 0 1.0em 1.0em 0;
  }

  .underline-copy p {
    margin: 0 1.0em 1.0em 0;
  }

  .subtitle {
    font-size: 0.65em;
  }
</style>
